export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole formuláře č."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chybí požadované ID"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšně jste se přihlásili, pokračujte v operacích na bankomatu"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokračujte v transakcích z bankomatu"])}
}